import { AppUser } from 'Src/views/App/App';
import axios from 'axios';
import { ALL_LIMIT } from 'Src/consts/table';

export function getPackage(user: AppUser, packageId: string) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios
    .get(`${window.apiBase}/admin/packages/${packageId}`, config)
    .then(response => {
      return response.data;
    });
}

export function getPackages(user: AppUser, filter) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter,
    },
  };

  return axios
    .get(`${window.apiBase}/admin/packages`, config)
    .then(response => {
      return response.data;
    });
}

export function getAllPackages(user: AppUser, where?) {
  const { sessionKey: key } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...where,
          },
          limit: ALL_LIMIT,
          skip: 0,
        },
      },
    };
  } else {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          limit: ALL_LIMIT,
          skip: 0,
        },
      },
    };
  }

  return axios
    .get(`${window.apiBase}/admin/packages`, config)
    .then(response => {
      return response.data;
    });
}

export function getPackagesCount(user: AppUser, where?) {
  const { sessionKey: key } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: where,
        },
      },
    };
  } else {
    config = {
      headers: { usid: key },
    };
  }

  return axios
    .get(`${window.apiBase}/admin/packages/count`, config)
    .then(response => {
      return response.data;
    });
}

export function addPackage(user: AppUser, data) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios
    .post(`${window.apiBase}/admin/packages`, data, config)
    .then(response => {
      return response.data;
    });
}

export function updatePackage(user: AppUser, packageId: string, data) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios
    .put(`${window.apiBase}/admin/packages/${packageId}`, data, config)
    .then(response => {
      return response.data;
    });
}

export function deletePackage(user: AppUser, packageId: string) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios
    .delete(`${window.apiBase}/admin/packages/${packageId}`, config)
    .then(response => {
      return response.data;
    });
}
